/* requries:
jquery-3.2.1.min.js
*/

(function ($, Drupal, drupalSettings) {

    'use strict';


    $(document).ready(function(){

        var hamburgerMenu = function() {
        	$('#nav-icon3').on('click', function(){
        		$(this).toggleClass('open');
        		$('#main-nav').toggleClass('open');
        	});

            $('#nav-icon-footer').on('click', function(){
                $(this).toggleClass('open');
                $('#footer-nav').toggleClass('open');
            });
        }

        var mobileDropdown = function() {
            $('.has-children').each(function(){
                $(this).on('click', function(){
                    $(this).toggleClass('open');
                    $(this).children('ul').toggleClass('open');
                });
            });
        }

        
        var canvasFallback = function() {
            if ($('.particles--container canvas').length === 0) {
                $('.particles--container #particles-static').show();
            }
        }
        

    	var init = function () {
            hamburgerMenu();
            mobileDropdown();
            canvasFallback();
    	}

    	init();
    });
})(jQuery, Drupal, drupalSettings);